export class ReqLockUnlockUser{
    userID: number = 0;
    isLocked: string = '';

    constructor(userId: number, isLocked: string){
        this.userID = userId;
        this.isLocked = isLocked;
    }
}